import {
  signUp,
  confirmSignUp,
  signIn,
  signOut,
  resetPassword,
  confirmResetPassword,
  resendSignUpCode,
  fetchUserAttributes,
  fetchAuthSession,
} from 'aws-amplify/auth';

const authService = {
  // ***********************************************************
  //                   New Account Creation
  // ***********************************************************
  createNewAccount: async ({
    email,
    password,
    givenName,
    familyName,
    phoneNumber,
  }) => {
    const response = await signUp({
      username: email,
      password,
      options: {
        userAttributes: {
          email,
          phone_number: phoneNumber,
          given_name: givenName,
          family_name: familyName,
        },
      },
    });
    return response;
  },

  // ***********************************************************
  //                    Confirm User Account
  // ***********************************************************
  confirmNewAccount: async ({ username, confirmationCode }) => {
    const response = await confirmSignUp({ username, confirmationCode });
    return response;
  },
  // ***********************************************************
  //                   Current User Information
  // ***********************************************************
  currentUserInfo: async () => {
    try {
      const attributes = await fetchUserAttributes();
      return { attributes };
    } catch {
      return null;
    }
  },

  // ***********************************************************
  //                     Authorize
  // ***********************************************************
  authorize: async ({ username, password }) => {
    await signIn({ username, password });
    const session = await fetchAuthSession();
    return session;
  },

  // ***********************************************************
  //                  Global Logout
  // ***********************************************************
  globalSignout: async () => {
    const response = await signOut({ global: true });
    return response;
  },

  // ***********************************************************
  //               Resend Account Confirmation Code
  // ***********************************************************
  resendConfirmationCode: async ({ username }) => {
    const response = await resendSignUpCode({ username });
    return response;
  },

  // ***********************************************************
  //               Reset Password - Get Code
  // ***********************************************************
  resetPassword: async ({ email }) => {
    const response = await resetPassword({ username: email });
    return response;
  },

  // ***********************************************************
  //               Reset Password - Submit Form
  // ***********************************************************
  resetPasswordSubmit: async ({ username, code, password }) => {
    const response = await confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword: password,
    });
    return response;
  },
};

export default authService;
